<template>
  <AppButtonExport
    :loading="serviceExport.loading"
    @export-csv="openExportCsv()"
    @export-pdf="openExportPdf()"
    @export-xlsx="openExportExcel()"
  ></AppButtonExport>
  <Dialog
    header="Relatório de bovinos do Serviço"
    style="min-width: 300px; max-width: 800px"
    :modal="true"
    v-model:visible="serviceExport.visible"
  >
    <div class="p-col-12 p-mb-4">
      Selecione abaixo as colunas que estarão presentes no relátorio.
    </div>
    <div class="p-grid">
      <div class="p-col-6 p-sm-2">
        <div class="p-field-checkbox">
          <Checkbox
            name="earring"
            :modelValue="true"
            :binary="true"
            :disabled="true"
          />
          <label for="earring"> Brinco </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox
            name="type"
            :modelValue="true"
            :binary="true"
            :disabled="true"
          />
          <label for="type"> Tipo </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox name="breed" v-model="columns.breed" :binary="true" />
          <label for="breed"> Raça </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox name="weight" v-model="columns.weight" :binary="true" />
          <label for="weight"> Peso </label>
        </div>
      </div>
      <div class="p-col-6 p-sm-3">
        <div class="p-field-checkbox">
          <Checkbox
            name="birthDate"
            v-model="columns.birthDate"
            :binary="true"
          />
          <label for="birthDate"> Data de Nascimento </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox name="age" v-model="columns.age" :binary="true" />
          <label for="age"> Idade </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox
            name="bovineRoot"
            v-model="columns.bovineRoot"
            :binary="true"
          />
          <label for="bovineRoot"> Matriz </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox name="status" v-model="columns.status" :binary="true" />
          <label for="status"> Status </label>
        </div>
      </div>
      <div class="p-col-6 p-sm-2">
        <div class="p-field-checkbox">
          <Checkbox name="bullType" v-model="columns.bullType" :binary="true" />
          <label for="bullType"> Touro </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox name="color" v-model="columns.color" :binary="true" />
          <label for="color"> Cor </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox name="farm" v-model="columns.farm" :binary="true" />
          <label for="farm"> Fazenda </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox name="farmLot" v-model="columns.farmLot" :binary="true" />
          <label for="farmLot"> Lote/Piquete </label>
        </div>
      </div>
      <div class="p-col-6 p-sm-3">
        <div class="p-field-checkbox">
          <Checkbox name="owner" v-model="columns.owner" :binary="true" />
          <label for="owner"> Proprietário </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox
            name="childBirth"
            v-model="columns.childBirth"
            :binary="true"
          />
          <label for="childBirth"> Previsão de Parto </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox name="tags" v-model="columns.tags" :binary="true" />
          <label for="tags"> Etiquetas </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox
            name="observation"
            v-model="columns.observation"
            :binary="true"
          />
          <label for="observation"> Observação </label>
        </div>
      </div>
      <div class="p-col-6 p-sm-2">
        <div class="p-field-checkbox">
          <Checkbox name="done" v-model="columns.done" :binary="true" />
          <label for="done"> Situação do Serviço </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox
            name="dateExecuted"
            v-model="columns.dateExecuted"
            :binary="true"
          />
          <label for="dateExecuted"> Data de Execução </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox
            name="serviceBull"
            v-model="columns.serviceBull"
            :binary="true"
          />
          <label for="serviceBull"> Inseminação </label>
        </div>
      </div>
      <div class="p-col-12">
        Por último, informe o número de paginas em branco que deseja imprimir e
        selecione a orientação do arquivo.
      </div>
    </div>
    <div class="p-grid p-jc-end p-mt-3">
      <template v-if="fileType === 'pdf'">
        <div class="p-col-12 p-lg-4">
          <InputNumber
            style="width: 100%"
            placeholder="Qtd. de folhas"
            v-model="serviceExport.emptyPages"
          />
        </div>
        <div class="p-col-12 p-lg-4">
          <AutocompleteApi
            style="width: 100%"
            v-model:value="serviceExport.template"
            :search="fetchReportTemplate"
            :placeholder="'Modelo'"
          ></AutocompleteApi>
        </div>
        <div class="p-col-fixed">
          <SplitButton
            label="Paisagem"
            @click="exportService('pdf-landscape')"
            :model="serviceExport.items"
          ></SplitButton>
        </div>
      </template>
      <template v-if="fileType === 'csv'">
        <div class="p-col-fixed" style="padding-bottom: 0">
          <AppButton label="Ok" @click="exportService('csv')"></AppButton>
        </div>
      </template>
      <template v-if="fileType === 'xlsx'">
        <div class="p-col-fixed" style="padding-bottom: 0">
          <AppButton label="Ok" @click="exportService('xlsx')"></AppButton>
        </div>
      </template>
    </div>
  </Dialog>
</template>

<script>
import debounce from 'debounce';
import { ReportTemplateApi, ServiceApi } from '../../../services/api';
import AutocompleteApi from '../../../components/AutocompleteApi.vue';

const getDefaultColumns = () => ({
  breed: true,
  weight: true,
  birthDate: true,
  age: true,
  bovineRoot: false,
  status: true,
  bullType: false,
  color: false,
  farm: true,
  farmLot: true,
  owner: false,
  childBirth: false,
  tags: true,
  observation: false,
  done: true,
  dateExecuted: true,
  serviceBull: true,
});

export default {
  name: 'ServiceEditExport',
  components: {
    AutocompleteApi,
  },
  data() {
    return {
      serviceExport: {
        visible: false,
        loading: false,
        emptyPages: null,
        template: null,
        items: [
          {
            label: 'Retrato',
            command: () => {
              this.exportService('pdf-portrait');
            },
          },
        ],
      },
      columns: getDefaultColumns(),
      fileType: null,
    };
  },
  methods: {
    openExportPdf() {
      this.columns = getDefaultColumns();
      this.fileType = 'pdf';
      this.serviceExport.visible = true;
    },
    openExportCsv() {
      this.columns = getDefaultColumns();
      this.fileType = 'csv';
      this.serviceExport.visible = true;
    },
    openExportExcel() {
      this.columns = getDefaultColumns();
      this.fileType = 'xlsx';
      this.serviceExport.visible = true;
    },
    fetchReportTemplate: ReportTemplateApi.fetch,
    exportService: debounce(
      async function exportService(format) {
        try {
          this.serviceExport.loading = true;
          this.serviceExport.visible = false;
          const dateStart = this.$dayjs(this.dateStart).format('DD-MM-YYYY');
          const extension = format.includes('pdf') ? 'pdf' : format;
          const filename = `Relatório de Serviço - ${this.$route.params.id} - ${dateStart}.${extension}`;
          const columns = Object.keys(this.columns).reduce((final, key) => {
            if (this.columns[key]) {
              final.push(key);
            }
            return final;
          }, []);
          const query = {
            emptyPages: this.serviceExport.emptyPages,
            template: this.serviceExport?.template?.id || undefined,
            columns: columns.join(','),
          };
          const data = await ServiceApi.export(
            this.$route.params.id,
            format,
            query
          );
          this.$downloadFile(filename, data);
        } finally {
          this.serviceExport.loading = false;
        }
      },
      500,
      true
    ),
  },
};
</script>

<style scoped>
div >>> .p-inputnumber-input {
  width: 100% !important;
}
</style>